import React, { useState, useEffect } from 'react';
import './Lottery.css';

const Lottery = () => {
  const [prizes, setPrizes] = useState('');
  const [isSpinning, setIsSpinning] = useState(false);
  const [winner, setWinner] = useState('');
  const [history, setHistory] = useState([]);
  const [prizeList, setPrizeList] = useState([]);

  // 当prizes输入变化时，实时更新prizeList
  useEffect(() => {
    const prizeArray = prizes
      .split('\n')
      .map(prize => prize.trim())
      .filter(prize => prize.length > 0);
    setPrizeList(prizeArray);
  }, [prizes]);

  const handlePrizesChange = (e) => {
    setPrizes(e.target.value);
  };

  const drawWinner = () => {
    if (prizeList.length === 0) {
      alert('请输入奖品名单！');
      return;
    }

    setIsSpinning(true);
    setWinner('');

    // 模拟抽奖动画
    const spinDuration = 3000;
    const spinInterval = 100;
    let spinCount = 0;

    const spin = setInterval(() => {
      const randomPrize = prizeList[Math.floor(Math.random() * prizeList.length)];
      setWinner(randomPrize);
      spinCount++;

      if (spinCount * spinInterval >= spinDuration) {
        clearInterval(spin);
        setIsSpinning(false);
        
        // 记录中奖历史
        const newHistory = {
          id: Date.now(),
          prize: randomPrize,
          timestamp: new Date().toLocaleString()
        };
        setHistory(prev => [newHistory, ...prev]);
      }
    }, spinInterval);
  };

  const clearHistory = () => {
    setHistory([]);
  };

  return (
    <div className="lottery">
      <h2>🎁 奖品抽奖系统</h2>
      
      <div className="lottery-section">
        <h3>奖品名单</h3>
        <textarea
          value={prizes}
          onChange={handlePrizesChange}
          placeholder="请输入奖品名单，每行一个奖品..."
          rows="6"
          className="prize-input"
        />
        <div className="prize-count">
          共 {prizeList.length} 个奖品
        </div>
      </div>

      <div className="lottery-section">
        <button 
          onClick={drawWinner} 
          disabled={isSpinning || prizeList.length === 0}
          className="draw-btn"
        >
          {isSpinning ? '🎲 抽奖中...' : '🎲 开始抽奖'}
        </button>
      </div>

      {winner && (
        <div className="winner-section">
          <h3>🎉 中奖奖品</h3>
          <div className={`winner-display ${isSpinning ? 'spinning' : ''}`}>
            {winner}
          </div>
        </div>
      )}

      {history.length > 0 && (
        <div className="history-section">
          <div className="history-header">
            <h3>📋 中奖历史</h3>
            <button onClick={clearHistory} className="clear-btn">
              清空历史
            </button>
          </div>
          <div className="history-list">
            {history.map(item => (
              <div key={item.id} className="history-item">
                <span className="prize-name">{item.prize}</span>
                <span className="timestamp">{item.timestamp}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Lottery;
